const queue = (() => {
  const storage = []; // this could be local storage / indexed db for offline analytics
  const push = ({ eventName, props, contextData, cb }) =>
    storage.push({ eventName, props, contextData, cb });
  const remove = () => storage.shift();
  const removeAll = () => {
    storage.length = 0;
    return true;
  };
  const length = () => storage.length;
  const isEmpty = () => !storage.length;
  const getAll = () => storage;
  return {
    push,
    remove,
    length,
    getAll,
    removeAll,
    isEmpty,
  };
})();

export default queue;
